enum Message {
  HELLO_WORLD = 'helloworld.message',
  언어변경 = 'header.change_language',
  문의하기 = 'header.contact_us',
  로그인 = 'header.login',
  간편로그인 = 'easy.login',
  로그아웃 = 'header.logout',
  회원가입 = 'header.join',
  // 내문서 = 'header.my_folder',
  내콘텐츠 = 'header.my_contents',
  준비중입니다 = 'header.open_preparation',

  학습도구 = 'menu.tool',
  이차원좌표공간에서기하대수코딩학습 = 'menu.tool.math2d_explain',
  차원좌표공간에서물리화학실험을시뮬레이션으로학습 = 'menu.tool.science2d_explain',
  삼차원좌표공간에서기하대수코딩학습 = 'menu.tool.math3d_explain',
  차원좌표공간에서대수학습 = 'menu.tool.algebra3d_explain',
  차원좌표공간에서입체도형쌓기나무학습 = 'menu.tool.cube_explain',
  차원공간에서입체도형심화학습 = 'menu.tool.figure3d_explain',
  수학과학데이터를활용한확률과통계표와그래프학습 = 'menu.tool.statistics_explain',
  초등학교수학수업을위한각종교구 = 'menu.tool.mathtools_explain',
  D분자구조를시각적으로탐색 = 'menu.tool.steammole_explain',
  디지털수업자료제작도구 = 'menu.tool.workbook_explain',
  시공간의제약없이체험하는디지털천문대 = 'menu.tool.observatory_explain',
  AI기초알고리즘학습및실습 = 'menu.tool.steamai_explain',
  ARVR환경에서수학과학개념을실감나게체험 = 'menu.tool.steamxr_explain',
  콘텐츠 = 'menu.contents',
  클래스룸 = 'menu.class_room',
  모둠 = 'menu.group',
  스토어 = 'menu.store',
  원하는콘텐츠를검색해보세요 = 'menu.search_placeholder',
  찾으시는콘텐츠를검색해보세요 = 'contents.search_placeholder',
  클래스룸생성 = 'create.classRoom',

  STEAMuP이란 = 'intro.section1.title',
  DigitalDynamicInteractiveSTEAM교육 = 'intro.section1.description1',
  수학과학코딩예술의융복합교육플랫폼입니다 = 'intro.section1.description2',

  화면에서도형대수블록코딩을활용한콘텐츠를만들수있는도구입니다 = 'intro.section2.description1',
  책으로만배웠던수학적인증명을확인해보세요 = 'intro.section2.description2',

  화면에서대수그래프를만들수있는도구입니다 = 'intro.section3.description1',
  상상속에있었던삼차원그래프를확인해보세요 = 'intro.section3.description2',

  화면에서입체도형과블록코딩을활용한콘텐츠를만들수있는도구입니다 = 'intro.section4.description1',
  궁금했던입체도형의모양과쌓여있는쌓기나무의개수를확인해보세요 = 'intro.section4.description2',

  화면에서물리엔진을활용한콘텐츠를만들수있는도구입니다 = 'intro.section5.description1',
  책으로만배웠던물리를실험을통해확인해보세요 = 'intro.section5.description2',

  큐브를활용한복셀아트와입체도형을활용한콘텐츠를수있는도구입니다 = 'intro.section6.description1',
  콘텐츠안에서자유롭게돌아다니면서구경해보세요 = 'intro.section6.description2',

  STEAMuP도구와다양한편집모듈을활용하여문서를제작할수있는도구입니다 = 'intro.section7.description1',
  문서를제작하여강의나발표자료에활용해보세요 = 'intro.section7.description2',

  다양한과학실험콘텐츠를구성하고시뮬레이션해볼수있습니다 = 'intro.section8.description1',
  물리화학천체등나만의과학교육콘텐츠를만들어보세요 = 'intro.section8.description2',

  정육면체큐브조각을이용해다양한입체를만들어보세요 = 'intro.section9.description1',
  코딩과결합되면더많은활동을해볼수있어요 = 'intro.section9.description2',

  DigitalDynamicInteractive한교육콘텐츠를구성해보세요 = 'intro.section10.description1',
  PPT형식으로교육콘텐츠를다양하게꾸밀수있습니다 = 'intro.section10.description2',

  콘텐츠보기 = 'intro.button.example',
  키워드보기 = 'intro.button.keyword_example',
  시작하기 = 'intro.button.execute',
  시작 = 'modal.button.start',

  마이페이지 = 'mypage.menu.mypage',
  계정관리 = 'mypage.accoundant.management',
  프로필 = 'mypage.menu.profile',
  프로필보기 = 'mypage.follow.profile',
  메신저보내기 = 'mypage.follow.messenger',
  신고하기 = 'mypage.follow.declaration',
  차단하기 = 'mypage.follow.block',
  정보수정 = 'mypage.menu.edit_profile',
  내정보수정 = 'new.mypage.menu.edit_profile',
  이메일 = 'mypage.email',
  비밀번호변경 = 'mypage.menu.change_password',
  계정탈퇴 = 'mypage.menu.unregist',
  계정설정 = 'mypage.menu.account_setting',
  포인트 = 'mypage.menu.point',
  포인트충전 = 'mypage.menu.charge_point',
  포인트사용내역조회 = 'mypage.menu.point_history',
  포인트사용내역이없습니다 = 'mypage.no.point',
  팔로우 = 'mypage.menu.follow',
  내가팔로우한창작자 = 'mypage.menu.followee',
  나를팔로우한사용자 = 'mypage.menu.follower',
  좋아요표시한콘텐츠 = 'mypage.menu.contents_like',
  다운로드한콘텐츠 = 'mypage.menu.contents_download',
  댓글남긴콘텐츠 = 'mypage.menu.contents_comment',
  초기화 = 'mypage.button.reset_avatar',
  변경 = 'mypage.button.change_avatar',
  정보수정을완료했습니다 = 'mypage.msg.success_edit_profile',
  현재$1계정으로로그인되어있습니다 = 'mypage.msg.logged_in_social',
  비밀번호변경이완료되었습니다 = 'mypage.msg.success_change_password',
  계정탈퇴시회원의개인정보가삭제되며복구할수없습니다 = 'mypage.unregist.paragraph1',
  업로드한콘텐츠나댓글등은함께삭제되지않을수있습니다 = 'mypage.unregist.paragraph2',
  탈퇴후7일동안동일한이메일로재가입이불가능합니다 = 'mypage.unregist.paragraph3',
  계정탈퇴를위해탈퇴사유를입력해주세요 = 'mypage.unregist.paragraph4',
  여러분의소중한의견이STEAMuP발전에큰힘이됩니다 = 'mypage.unregist.paragraph5',
  계정탈퇴를위해약관동의가필요합니다 = 'mypage.unregist.agreement',
  해당내용을숙지하였으며약관에동의합니다 = 'mypage.withdrawl.agreement',
  탈퇴사유 = 'mypage.unregist.reason',
  탈퇴사유를선택하세요 = 'mypage.unregist.choose_unregist_reason',
  탈퇴사유를입력하세요 = 'mypage.unregist.input_unregist_reason',
  사유입력 = 'mypage.unregist.input_unregist_reason_short',
  탈퇴하기 = 'mypage.unregist.unregist_button',
  사용빈도가낮음 = 'mypage.unregist.reason_1',
  개인정보침해우려 = 'mypage.unregist.reason_2',
  서비스응대불만 = 'mypage.unregist.reason_3',
  원하는콘텐츠가부족 = 'mypage.unregist.reason_4',
  사용방법이어려움 = 'mypage.unregist.reason_5',
  가격불만 = 'mypage.unregist.reason_6',
  기타직접입력 = 'mypage.unregist.reason_7',
  사용중인비밀번호를입력해주세요 = 'mypage.unregist.input_password',
  정말로$1님의탈퇴를진행할까요 = 'mypage.unregist.confirm_unregist',
  계정탈퇴가완료되었습니다STEAMuP을이용해주셔서감사드립니다 = 'mypage.unregist.finish_unregist',
  보유포인트 = 'mypage.charge_point.point_in_hand',
  잔여포인트 = 'mypage.charge_remaining_point',
  보유마일리지 = 'mypage.charge_point.mileage_in_hand',
  잔여마일리지 = 'mypage.charge_remaining_mileage',
  결제진행중입니다현재창을끄지마세요 = 'mypage.charge_point.payment_is_processing',
  팝업차단을해제해주세요 = 'mypage.charge_point.please_release_popup',
  결제가완료되었습니다 = 'mypage.charge_point.payment_success',
  결제실패 = 'mypage.charge_point.payment_fail',
  알수없는이유 = 'mypage.charge_point.unknown_reason',
  결제가취소되었습니다 = 'mypage.charge_point.payment_cancel',
  결제하기 = 'mypage.charge_point.button.payment',
  마일리지 = 'mypage.point_history.mileage',
  $1건조회 = 'mypage.point_history.view_count',
  총$1건 = 'mypage.point_history.view_count2',
  잔액 = 'mypage.point_history.balance',
  조회 = 'mypage.point_history.inquiry', // 한글은 같은데 영문이 다를 경우? hits
  조회기간 = 'mypage.point_history.inquiry_period',
  팔로잉 = 'mypage.follow.following',
  언팔로우 = 'mypage.follow.unfollowing',
  $1명의팔로워 = 'mypage.follow.follower_cnt',
  $1개의콘텐츠 = 'mypage.follow.contents_cnt',
  콘텐츠관리 = 'mypage.contents.management',
  클래스관리 = 'mypage.class.management',
  강의대시보드 = 'mypage.lecture.dashboard',
  포인트구매 = 'mypage.point.purchase',
  원 = 'mypage.point.won',
  최신순 = 'mypage.follow.from_the_latest',
  교류많은순 = 'mypage.follow.order_of_exchange',
  교류적은순 = 'mypage.follow.low_order_of_exchange',

  // 내 콘텐츠 페이지
  상위폴더로이동 = 'document.go_to_parent_folder',
  새폴더만들기 = 'document.create_new_folder',
  이름변경 = 'document.change_name',
  이동 = 'document.move',
  복제 = 'document.duplicate',
  삭제 = 'document.delete',
  이동할폴더를선택해주세요 = 'document.select_move_folder',
  같은이름의폴더가존재하여이동할수없습니다 = 'document.cannot_move_folder',
  같은이름의파일이존재하여이동할수없습니다 = 'document.cannot_move_file',
  같은이름의폴더가존재합니다 = 'document.folder_name_already_exists',
  해당폴더에같은이름의파일이존재합니다 = 'document.file_name_already_exists',
  대상폴더가원본폴더의하위폴더입니다 = 'document.cannot_move_lower_folder',
  대상폴더가존재하지않습니다 = 'document.target_folder_does_not_exists',
  $1폴더로$2개의파일을이동할까요 = 'document.confirm_move_files',
  선택한파일$1개 = 'document.selected_files',
  여기로이동 = 'document.move_here',
  새로고침 = 'document.refresh',
  열기 = 'document.open',
  편집 = 'document.edit',

  // 수정
  선택된폴더를모두삭제하시겠습니까 = 'document.confirm_delete.folder',
  선택된파일을모두삭제하시겠습니까 = 'document.confirm_delete.file',
  선택된$1개의폴더가삭제되며폴더안의내용도모두삭제됩니다 = 'document.warning_delete_folder',
  선택된$1개의파일이삭제됩니다 = 'document.warning_delete_file',

  // 내 콘텐츠
  내문서에서검색 = 'document.search_in_document', // 추후 삭제해야함
  내콘텐츠에서검색 = 'document.search_in_mycontents',
  정렬 = 'document.sort',
  정렬종류 = 'document.sort_type',
  정렬종류이름 = 'document.sort_type_name',
  정렬종류생성일 = 'document.sort_type_created',
  정렬종류최근수정일 = 'document.sort_type_updated',
  정렬방향 = 'document.sort_direction',
  정렬방향오름차순 = 'document.sort_direction_asc',
  정렬방향내림차순 = 'document.sort_direction_desc',

  추천콘텐츠 = 'contents.recommend_contents',
  인기콘텐츠 = 'contents.popular_contents',
  신규콘텐츠 = 'contents.new_contents',
  콘텐츠더보기 = 'contents.more_view_contents',
  콘텐츠가없습니다 = 'contents.no_contents',
  다빈치스튜디오 = 'contents.davinci_studio',
  창작자순위 = 'contents.creator_rank',
  자문위원 = 'contents.AdvisoryMember',

  다운로드폴더선택 = 'content_detail.choose_download_folder',
  공유하기 = 'content_detail.share',
  페이스북 = 'content_detail.share_facebook',
  트위터 = 'content_detail.share_twitter',
  링크복사 = 'content_detail.copy_link',
  좋아요 = 'content_detail.like',
  좋아요취소 = 'content_detail.unlike',
  편집하기 = 'content_detail.edit',
  댓글$1개 = 'content_detail.comment_count',
  댓글입력 = 'content_detail.input_comment',
  댓글을입력해주세요 = 'content_detail.please_input_comment',
  댓글달기 = 'content_detail.submit_comment',
  정말로댓글을삭제할까요 = 'content_detail.confirm_delete_comment',
  삭제가완료되었습니다 = 'content_detail.complete_delete_comment',
  댓글수정 = 'content_detail.edit_comment',
  창작자 = 'content_detail.creator',
  수정됨 = 'content_detail.edited',
  자세히보기 = 'content_detail.more_view_comment',
  조회수$1 = 'content_detail.view_count',
  다운로드수$1 = 'content_detail.download_count',
  블록코딩실행 = 'content_detail.play_blockcoding',
  스크립트코딩실행 = 'content_detail.play_scriptcoding',
  스크립트코딩정지 = 'content_detail.stop_scriptcoding',
  과학모드실행 = 'content_detail.play_science',
  과학모드정지 = 'content_detail.stop_science',
  전체화면 = 'content_detail.fullscreen',
  구매하기 = 'content_detail.purchase',
  재구매하기 = 'content_detail.re_purchase',
  포인트가부족합니다 = 'content_detail.not_enough_point',
  마일리지가부족합니다 = 'content_detail.not_enough_mileage',
  이미구매한콘텐츠입니다 = 'content_detail.already_purchased',
  본인콘텐츠입니다 = 'content_detail.self_purchase',
  다운로드가금지된콘텐츠입니다 = 'content_detail.unexportable',
  $1p를사용하여구매하시겠습니까 = 'content_detail.confirm_purchase',
  구매가완료되었습니다 = 'content_detail.purchase_successfully',

  메뉴 = 'tool.header.menu',
  내PC에서불러오기 = 'tool.header.load_on_pc',
  파일이름을입력하세요 = 'tool.header.input_file_name',
  다운로드 = 'tool.header.download',
  내PC에다운로드 = 'tool.header.save_to_pc',
  새로만들기 = 'tool.header.new',
  내문서에서불러오기 = 'tool.header.load_from_my_folder',
  내문서에저장하기 = 'tool.header.save_on_my_folder',
  내문서에다운로드하기 = 'tool.header.download_on_my_folder',
  다른이름으로저장하기 = 'tool.header.save_as_on_my_folder',
  현재작업중인내용이저장되지않습니다계속하시겠습니까 = 'tool.header.continue',
  선택된파일이없습니다 = 'tool.save.selected_file_does_not_exist',
  파일을선택하세요 = 'tool.save.choose_the_file',
  태그는5개까지입력가능합니다 = 'tool.save.exceed_tag_limit',
  본인외저장이금지된파일입니다 = 'tool.save.disallow_save',
  저장이완료되었습니다 = 'tool.save.success_save',
  저장폴더선택 = 'tool.save.choose_the_folder',
  파일이름 = 'tool.save.file_name',
  미리보기이미지 = 'tool.save.thumbnail_image',
  세부정보입력 = 'tool.save.more_detail_button',
  설명글 = 'tool.save.description',
  콘텐츠를설명하는글을입력해주세요 = 'tool.save.input_description',
  교육과정 = 'tool.save.curriculum',
  태그 = 'tool.save.tag',
  태그선택후추가버튼을누르세요 = 'tool.save.add_tag_msg',
  콘텐츠접근권한 = 'tool.save.accessablity',
  공개 = 'tool.save.public',
  공개안함 = 'tool.save.private',
  타인저장허용 = 'tool.save.exportable',
  다른사람들이콘텐츠를조회하고다운로드할수있습니다 = 'tool.save.accessabllity_help_msg1',
  다른사람들이콘텐츠를조회할수있지만다운로드할수없습니다 = 'tool.save.accessabllity_help_msg2',
  콘텐츠를나만볼수있습니다 = 'tool.save.accessabllity_help_msg3',

  공지사항 = 'forum.notice',
  자료실 = 'forum.download',
  질문답변 = 'forum.qna',
  더보기 = 'forum.more',

  추천_콘텐츠 = 'recommended.recommended_contents',
  추천_모둠 = 'recommended.recommended_groups',
  추천_클래스 = 'recommended.recommended_classes',
  콘텐츠_스토어 = 'recommended.contents_store',

  이용약관 = 'footer.terms_of_service',
  개인정보처리방침 = 'footer.privacy_policy',

  선택 = 'common.choose',
  선택하기 = 'common.choose.2',
  나가기 = 'common.exit',
  확인 = 'common.confirm',
  취소 = 'common.cancel',
  추가 = 'common.add',
  수정 = 'common.edit',
  탈퇴한사용자 = 'common.left_user',
  과목 = 'common.subject',
  학년 = 'common.grade',
  충전 = 'common.charge',
  파일이름은최대$1자까지입력가능합니다 = 'common.validator.file_max_length',
  파일이름에특수문자$1를사용할수없습니다 = 'common.validator.file_special_charactor',
  설명글은최대$1자까지입력가능합니다 = 'common.validator.max_description',
  비밀번호를$1자이상입력해주세요 = 'common.validator.min_password',
  비밀번호를$1자이하로입력해주세요 = 'common.validator.max_password',
  영어대소문자 = 'common.validator.pw_english',
  숫자 = 'common.validator.pw_number',
  비밀번호는$1로입력해주세요 = 'common.validator.pw_rule',
  이름을입력해주세요 = 'common.validator.input_name',
  이름은최소$1자이상입력해주세요 = 'common.validator.input_min_length',
  이름은최대$1자이하까지입력가능합니다 = 'common.validator.input_max_length',

  서비스이용에불편을드려죄송합니다 = 'error.500.Title',
  현재서비스이용이원활하지않습니다 = 'error.500.Causation',
  잠시후다시시도하시거나관리자에게문의해주세요 = 'error.500.Description',
  처리도중서버에서오류가발생했습니다잠시후다시시도하시거나관리자에게문의해주세요 = 'error.500.internal_server_error',
  댓글을불러오는데실패했습니다 = 'error.500.fail_to_get_comments',
  리뷰를불러오는데실패했습니다 = 'error.500.fail_to_get__class_room_review',
  브라우저에서WEBGL2를지원하지않습니다 = 'error.403.not_support_webgl2',

  pc에서이용가능한서비스입니다 = 'error.only_pc_service',
  지원하지않는해상도입니다 = 'error.unsupported_resolution',
  해당서비스를이용하시려면화면크기를993px이상으로변경해주시기바랍니다 = 'error.unsupported_resolution_message',

  요청한페이지를찾을수없습니다 = 'error.400.Title',
  요청하신주소의페이지는사라졌거나다른페이지로변경되었을수있습니다 = 'error.400.Causation',
  주소를다시확인해주세요 = 'error.400.Description',
  콘텐츠가삭제되었거나존재하지않습니다 = 'error.400.contents_does_not_exist',
  댓글이삭제되었거나존재하지않습니다 = 'error.400.comment_does_not_exist',
  댓글수정권한이없습니다 = 'error.401.unauthorized_put_comment',
  댓글삭제권한이없습니다 = 'error.401.unauthorized_delete_comment',

  // 메인 검색
  제목또는키워드로검색해보세요 = 'home.search.keyword',
  최근검색어 = 'home.search.recent',
  전체삭제 = 'home.search.delete.all',
  인기검색어 = 'home.search.popular',
  검색결과가없습니다 = 'home.search.no.result',
  최근검색결과가없습니다 = 'home.search.no.recent',
  $1에대한검색결과가없습니다 = 'home.search.term.no_exist',

  // 클래스룸
  // 클래스룸 생성
  클래스생성 = 'classroom.create',
  클래스수정 = 'classroom.create.edit',
  작성중인클래스가있습니다나가시겠습니까 = 'classroom.create.exit',
  저장하지않고페이지를벗어날경우작성된내용이사라질수있습니다 = 'classroom.create.exit.info',
  클래스의형식이올바르지않습니다다시확인해주세요 = 'classroom.create.validation',
  클래스가정상적으로등록되었습니다 = 'classroom.create.sucess.post',
  클래스가정상적으로저장되었습니다 = 'classroom.create.sucess.save',
  미리보기가실행중입니다 = 'classroom.create.preview.running',
  $1자동저장됨 = 'classroom.create.auto_save',
  $1자동저장실패 = 'classroom.create.auto_save_fail',
  저장 = 'classroom.create.save',
  저장중 = 'classroom.create.saving',
  작성중 = 'classroom.create.writing',
  수정중 = 'classroom.create.editing',
  게시하기 = 'classroom.create.post',

  // 약관동의
  이용약관에동의합니다 = 'classroom.agree.to.the.terms.of.sale',

  // ! 스토어
  에셋 = 'store.essets',
  원하는스토어를검색해보세요 = 'store.search_placeholder',
  판매하기 = 'store.sale',
  내가찜한상품 = 'store.bookmark.product',
  찜한상품이없습니다 = 'store.none.bookmark',
  최근본상품 = 'recent.view.product',
  판매등록 = 'sell.enroll',
  판매등록을위한정보를설정후등록해주세요 = 'please.info.before.enroll',
  상품제목 = 'product.title',
  상품설명 = 'desc.product',
  학습도구선택 = 'select.learning.tool',
  서비스이용을위해판매약관동의가필요합니다 = 'must.agree.to.the.terms.of.sale',
  판매자이용약관 = 'seller.terms.conditions',
  판매이용약관에동의합니다 = 'agree.to.the.terms.of.sale',
  상품금액 = 'product.amount',
  할인금액 = 'discount.amount',
  할인기간 = 'discount.period',
  스토어가삭제되었거나존재하지않습니다 = 'error.400.store_does_not_exist',
  스토어관리 = 'store.management',
  구매목록 = 'purchase.list',
  콘텐츠신고하기 = 'content.declaration',
  관련없는내용 = 'irrelevant.content',
  주문일시 = 'order.date.and.time',
  주문목록 = 'order.list',
  결제금액 = 'amount.of.payment',
  판매자정보 = 'seller.information',
  결제정보 = 'payment.information',
  결제가완료된내역입니다 = 'this.is.payment.completed',
  이미지저장 = 'save.image',
  환불요청 = 'refund.required',
  상품유형$1 = 'product.type',
  구매했지만받지못함 = 'purchased.but.did.not.receive',
  구입항목이제대로작동하지않습니다 = "my.purchase.isn't.working.properly",
  환불요청이완료되었습니다 = 'your.refund.request.has.been.completed',
  환불사유를입력해주세요 = 'please.enter.the.reason.for.the.refund',
  환불사유를선택해주세요 = 'please.select.a.reason.for.your.refund',
  유형선택 = 'select.type',
  상품유형을선택해주세요 = 'please.select.a.product.type',
  무료유료 = 'free.pay',
  유료 = 'pay',
  최신콘텐츠 = 'latest.content',
  다운로드수 = 'number.of.downloads',
  높은가격 = 'high.price',
  낮은가격 = 'low.price',
  상품소개 = 'product.introduction',
  댓글 = 'comment',
  팔로우취소 = 'unfollow',
  팔로우하기 = 'follow',
  $1자 = 'number.of.characters',
  다운로드설정 = 'download.settings',
  편집가능 = 'editable',
  편집불가능 = 'not.editable',
  키워드는최대$1개까지입력가능합니다 = 'up.to.keywords.can.be.entered',
  상품키워드 = 'product.keyword',
  상품키워드를설정하면검색확률을높일수있습니다 = 'setting.product.keywords.can.increase.your.search.probability',
  상품키워드를입력해주세요 = 'please.enter.the.product.keyword',
  할인기간을설정해주세요 = 'please.set.a.discount.period',
  할인기간이$1년$2월$3일부터$4년$5월$6일까지설정되었습니다 = 'the.discount.period.is.set.from',
  할인기간이종료되면기존상품금액으로자동변경됩니다 =
  'when.the.discount.period.ends.the.price.will.automatically.change.to.the.original.product.price',
  $1시 = 'o.clock',
  $1분 = 'minutes',
  직접선택 = 'choose.your.own',
  상품금액은천만원미만으로설정가능합니다 = 'the.product.price.can.be.set.to.less.than.10.million.won',
  상품금액을입력해주세요 = 'please.enter.the.product.amount',
  $1할인적용됨 = 'discount.applied',
  주문금액 = 'order.amount',
  내마일리지 = 'my.mileage',
  내포인트 = 'my.point',
  총결제금액 = 'total.payment.amount',
  총결제금액보다높게입력할수없습니다 = 'you.cannot.enter.a.higher.amount.than.the.total.payment.amount',
  보유하신포인트이상으로사용할수없습니다 = 'you.cannot.use.more.points.than.you.have',
  보유하신마일리지이상으로사용할수없습니다 = 'you.cannot.use.more.mileage.than.you.have',
  모두사용 = 'use.all',
  주문유형 = 'order.type',
  판매유형$1 = 'sales.type',
  구매동의 = 'purchase.consent',
  구매이용약관에동의합니다 = 'i.agree.to.the.purchase.terms.and.conditions',
  판매유형을선택해주세요 = 'please.select.a.sales.type',
  다운받기 = 'download',
  포인트와마일리지를합산한금액이결제금액보다많습니다 = 'the.combined.amount.of.points.and.mileage.is.more.than.the.payment.amount',
  결제금액을확인해주세요 = 'please.check.the.payment.amount',
  이용약관에동의해주세요 = 'please.agree.to.the.terms.of.use',
  마일리지사용안내 = 'mileage.usage.information',
  상품환불시마일리지를제외한금액만환불이가능합니다 = 'when.refunding.a.product.only.the.amount.excluding.mileage.can.be.refunded',
  결제하시겠습니까 = 'would.you.like.to.pay',
  결제 = 'payment',
  구매가성공적으로처리되었습니다 = 'your.purchase.has.been.processed.successfully',
  구매유형선택 = 'select.purchase.type',
  다음결제정보를확인하시고결제를진행해주세요 = 'please.check.the.following.payment.information.and.proceed.with.payment',
  $1원 = 'won',
  다운로드기간만료 = 'download.period.expires',
  찜한목록 = 'wishlist',
  환불내역 = 'refund.list',
  판매자닉네임 = 'seller.nickname',
  유형 = 'type',
  결제포인트 = 'payment.point',
  환불요청일시 = 'refund.request.date.and.time',
  구매확정하시겠습니까 = 'would.you.like.to.confirm.your.purchase',
  구매확정이완료되었습니다 = 'your.purchase.has.been.confirmed',
  구매확정 = 'purchase.confirmation',
  환불요청하기 = 'request.a.refund',
  찜하기취소 = 'cancel.bookmark',
  찜하기 = 'bookmark',
  단순변심 = 'simple.change.of.mind',
  신고가정상적으로제출되었습니다 = 'the.report.has.been.submitted.correctly',
  $1년$2월$3일 = 'year.month.day',
  카테고리='category',
  카테고리선택은필수사항입니다='enroll.required.category',
  판매유형선택은필수사항입니다='enroll.required.salesType',
  할인종료기간은할인시작기간보다빠를수없습니다='enroll.error.discount.period',
  할인종료기간을선택해주세요='enroll.required.discount.period',
  다운로드설정선택은필수사항입니다='enroll.required.download.option',
  학습도구업로드는필수사항입니다='enroll.required.learning.tool',
  업로드할학습도구의유형은동일해야합니다='enroll.required.same.learning.tool',
  상품제목은필수사항입니다='enroll.required.title',
  상품설명은필수사항입니다='enroll.required.description',
  판매이용약관에동의해주세요='enroll.required.policy',
  할인금액을입력해주세요='enroll.required.discount',
  스토어등록이완료되었습니다='enroll.register.success',
  상품제목을입력해주세요='enroll.product.title',
  상품상세설명을입력해주세요='enroll.product.description',
  학습도구업로드='enroll.learning.tool.upload',
  판매상품의파일을업로드해주세요='enroll.learning.tool.upload.description',
  기타자료업로드='enroll.other.files.upload',
  기타자료를업로드해주세요='enroll.other.files.upload.description',
  구매유형1='purchase.type1',
  구매유형2='purchase.type2',
  구매수 = 'detail.purchase.count',
  신고한내역은마이페이지신고내역신고내역조회에서확인할수있습니다 = 'you.can.check.the.reported.details.at.my.page.report.details.view.report.details',
  콘텐츠자료오류 = 'content.material.error',
  신고상세입력 = 'enter.report.details',
  신고내용을상세하게입력해주세요 = 'please.enter.your.report.in.detail',
  콘텐츠오류이미지 = 'content.error.image',
  신고제출 = 'submit.report',
  광고 = 'advertisement',
  홍보글 = 'promotional.post',
  개인정보유출 = 'personal.information.extrusion',
  욕설 = 'abuse',
  음란 = 'lewd',
  선정성 = 'sensationalism',
  기타 = 'etc',
  이용약관전체내용 = 'store.terms.of.use',

  // 판매 관리(관리자 대시보드)
  대시보드='admindashboard',
  매출현황='admindashboard.revenue.status',
  판매현황='admindashboard.sales.status',
  날짜별현황='admindashboard.date.status',
  대시보드관리자='admindashboard.admin',
  관리자종료='admindashboard.admin.end',

  판매관리 ='admindashboard.sales_mgmt',
  매출='admindashboard.revenue',
  년='admindashboard.year',
  월='admindashboard.month',
  $1현황='admindashboard.status',

  판매날짜시간='admindashboard.sales.data_and_time',
  YYYY년MM월DD일='admindashboard.sales.yyyymmdd',
  판매결제금액='admindashboard.sales.payment_amount',
  상품명='admindashboard.sales.product_name',

  날짜별요약='admindashboard.date.date_summary',
  날짜='admindashboard.date.date',
  주문수='admindashboard.date.num_of_order',
  매출액='admindashboard.date.revenue',
  환불건='admindashboard.date.num_of_refund',

  전체상품='admindashboard.product.all',
  판매중='admindashboard.product.selling',
  판매종료='admindashboard.product.selling_end',
  환불완료='admindashboard.product.refund',
  상품명키워드로검색='admindashboard.product.search',

  등록날짜시간='admindashboard.regist.date_and_time',
  대시보드상품금액='admindashboard.price',
  판매수='admindashboard.selling_num',
  판매상태='admindashboard.selling_state',
  상세보기='admindashboard.detail',

  판매유형='admindashboard.product_type',
  유형$1='admindashboard.product_type.item',

  // 판매상태 모달
  종료날짜시간='admindashboard.end.date_and_time',
  판매금액='admindashboard.selling.price',
  상태변경하기='admindashboard.change.status',
  변경하기='admindashboard.change',

  // 구매자현황모달
  구매자현황='admindashboard.customer.status',
  구입날짜시간='admindashboard.purchase.date_and_time',
  구매자닉네임='admindashboard.customer.nick_name',
  구매자계정='admindashboard.customer.email',
  처리상태='admindashboard.processing.status',

  // 환불정보
  환불정보='admindashboard.refund.info',
  환불처리가완료된내역입니다='admindashboard.refund.sub-info',
  구매자정보='admindashboard.refund.customer.info',
  환불사유='admindashboard.refund.reason',
  환불된금액='admindashboard.refund.price',

  // 수정 컨펌 메시지
  정말클래스를수정하시겠습니까 = 'update.confirm.title',
  수정한클래스는되돌릴수없습니다 = 'update.confirm.msg',
  게시중 = 'classroom.create.posting',
  미리보기 = 'classroom.create.preview',
  미리보기종료 = 'classroom.create.preview.exit',
  강의기본정보 = 'classroom.create.class.info',
  강의분야 = 'classroom.create.subject',
  학년구분 = 'classroom.create.grade',
  키워드 = 'classroom.create.keyword',
  수강료 = 'classroom.create.price',
  수강기한 = 'classroom.create.expiredAt',
  난이도 = 'classroom.create.level',
  강의제목 = 'classroom.create.title',
  강의상세소개 = 'classroom.create.class.detail',
  커버이미지 = 'classroom.create.thumbnail',
  강의상세내용 = 'classroom.create.content',
  강의과정 = 'classroom.create.process',
  강의목록구성 = 'classroom.create.order',
  설정및제출 = 'classroom.create.submit',
  판매이용약관 = 'classroom.create.policy',
  강의관련키워드를설정하면검색확률을높일수있습니다 = 'classroom.create.keyword_notice',
  수강신청시점으로부터제공되는기한입니다 = 'classroom.create.expired_notice',
  클래스등록과정 = 'classroom.create.sidebar_title',
  클래스작성하기 = 'classroom.create.write_title',

  $1강 = 'classroom.detail.lecture',
  강의$1강활동$2 = 'classroom.detail.lecture_activity',
  구매시점으로부터$1일 = 'classroom.detail.expired_at',
  $1일수정됨 = 'classroom.detail.edited_date',
  과정활동 = 'classroom.detail.process_activity',
  게시자 = 'classroom.detail.poster',
  생성날짜 = 'classroom.detail.created_date',

  // 수강기한
  $1일 = 'classroom.create.expired_days',
  무제한 = 'classroom.create.expired_none',
  직접입력 = 'classroom.create.direct_input',
  $1일현재날짜기준으로$2일종료 = 'classroom.create.expired_at',

  // 제목, 부제목
  강의제목$1자이내 = 'classroom.create.title_placeholder',
  강의부제목$1자이내 = 'classroom.create.subtitle_placeholder',

  // 썸네일
  커버이미지가등록되어있지않습니다 = 'classroom.create.images.no_cover_img',
  커버이미지추가 = 'classroom.create.images.add_cover_img',
  이미지는최대$1개까지업로드가능합니다 = 'classroom.create.images.add_maximum_amount',
  업로드가능한파일형식JPEGPNGGIF = 'classroom.create.images.upload_file_form',
  업로드가능한최대용량$1 = 'classroom.create.images.add_maximum_capa',
  용량초과로업로드에실패하였습니다 = 'classroom.create.images.fail',

  // 초대번호
  초대번호설정 = 'classroom.create.invite_code.setting',
  초대번호는최대$1자까지입력가능합니다 = 'classroom.create.invite_code.max_length',
  초대번호는최대20자까지입력가능합니다초대번호설정시초대번호를입력해야입장가능합니다 = 'classroom.create.invite_code.info',

  제목은70자이하로입력해주세요 = 'classroom.create.warning.title_length',
  부제목은200자이하로입력해주세요 = 'classroom.create.warning.subtitle_length',
  활동$1의제목을입력해주세요 = 'classroom.create.warning.order_activity_title',
  활동$1을작성해주세요 = 'classroom.create.warning.order_activity.content',
  $1강의제목을입력해주세요 = 'classroom.create.warning.order_lecture_title',
  $1강에활동을추가해주세요 = 'classroom.create.warning.activity',
  잘못된값입니다 = 'classroom.create.warning.wrong_value',

  // 판매약관미동의 // TODO: 워딩확인받기
  판매약관에동의해주세요 = 'classroom.create.warning.argree.policy',

  강의주제를입력해주세요 = 'classroom.create.input_lecture',
  활동제목을입력해주세요 = 'classroom.create.input_activity',
  작성하기 = 'classroom.create.lecture.create',
  삭제하기 = 'classroom.create.lecture.delete',
  강의추가 = 'classroom.create.lecture.add',
  수정하기 = 'classroom.create.lecture.edit',

  // 계정 발급
  클래스룸계정발급관리 = 'classroom.account.modal_title',
  선택한클래스룸에가입된사용자계정을신규발급하고관리할수있습니다 = 'classroom.account.modal_description',
  클래스룸을선택해주세요 = 'classroom.account.choose_class_room',
  발급한사용자계정이없습니다 = 'classroom.account.no_created_account',
  선택된클래스룸이없습니다 = 'classroom.account.no_selected_classroom',
  신규계정발급을완료했습니다 = 'classroom.account.issue_account_success',
  클래스룸임시계정삭제권한이없습니다 = 'classroom.account.issue_account_delete',
  아이디접두사 = 'classroom.account.prefix',
  아이디접두사설명1 = 'classroom.account.prefix_tooltip1', // 계정 생성시 아이디 앞에 붙을 접두사를 입력해주세요.
  아이디접두사설명2 = 'classroom.account.prefix_tooltip2', // 접두사+숫자 조합 아이디로 계정이 발급됩니다.
  아이디접두사설명3 = 'classroom.account.prefix_tooltip3', // 영소문자(a~z)와 밑줄(_)기호만 사용할 수 있습니다.
  클래스룸계정신규발급 = 'classroom.account.issue_new_account',
  클래스룸계정신규발급설명 = 'classroom.account.issue_new_account_tooltip', // 발급할 계정의 닉네임과 비밀번호를 입력해주세요.
  신규계정발급하기 = 'classroom.account.issue_button',
  계정발급개수 ='classroom.account.issue_account_count',
  아이디자동생성 ='classroom.account.auto_create_id',
  발급 ='classroom.account.issue',
  활성화 = 'classroom.account.account_table_column.enable',
  활성화설명1 = 'classroom.account.account_table_column.enable_tooltip1', // 해당 계정을 비활성화 또는 활성화합니다.
  활성화설명2 = 'classroom.account.account_table_column.enable_tooltip2', // 비활성화된 계정은 즉시 사용할 수 없게 됩니다.
  아이디 = 'classroom.account.account_table_column.id',
  아이디설명 = 'classroom.account.account_table_column.id_tooltip', // 로그인 시 이메일입력란에 입력할 ID입니다.
  비밀번호설명1 = 'classroom.account.account_table_column.password_tooltip1', // 설정한 비밀번호는 암호화되어 나중에 다시 확인할 수 없습니다.
  비밀번호설명2 = 'classroom.account.account_table_column.password_tooltip2', // 비밀번호를 잊었다면 비밀번호를 재설정 해주세요.
  최근활동일 = 'classroom.account.account_table_column.last_action_at',
  계정을활성화했습니다 = 'classroom.account.enable_account',
  계정을비활성화했습니다 = 'classroom.account.disable_account',
  닉네임변경을완료했습니다 = 'classroom.account.change_nickname_success',
  비밀번호변경을완료했습니다 = 'classroom.account.change_password_success',
  아이디접두사를입력하세요 = 'classroom.account.prefix_rule.empty',
  아이디접두사는3자이상이어야합니다 = 'classroom.account.prefix_rule.min_length',
  아이디접두사는20자이하이어야합니다 = 'classroom.account.prefix_rule.max_length',
  다른곳에서사용중인아이디접두사입니다 = 'classroom.account.prefix_rule.already_used',
  아이디접두사는영소문자와_만사용가능합니다 = 'classroom.account.prefix_rule.limit_character',

  // 클래스룸 강의 활동
  모든강의를마쳤습니다 = 'classroom.play.finished.done',
  이번강의는어땠나요 = 'classroom.play.finished.how_was_lecture',
  학습후기2 = 'classroom.play.finished.review',
  를남겨주세요 = 'classroom.play.finished.leave_review',
  소요된총학습시간 = 'classroom.play.finished.all_playing_time',
  학습후기작성 = 'classroom.play.finished.wirte_review',
  클래스룸으로이동 = 'classroom.play.finished.goto_classroom',
  질문 = 'classroom.play.finished.question',
  질문들 = 'classroom.play.finished.questions',
  $1개질문등록 = 'classroom.play.finished.register_question',
  $1개질문들등록 = 'classroom.play.finished.register_questions',
  뒤로가기 = 'classroom.play.finished.back',
  답변완료 = 'classroom.play.finished.answer_complete',
  답변작성하기 = 'classroom.play.finished.write_answer',
  답변하기='classroom.play.question_answer',
  질문에대한답변을남길수있어요 = 'classroom.play.finished.can_leave_answer',
  내용을입력해주세요 = 'classroom.play.finished.enter_contents',
  질문작성하기 = 'classroom.play.finished.write_question',
  비공개질문입니다 = 'classroom.play.finished.private_question',
  학습과관련된질문을남길수있어요 = 'classroom.play.finished.write_question_tooltip',
  메일알림 = 'classroom.play.finished.mail_notification',
  닫기 = 'classroom.play.finished.close',
  등록하기 = 'classroom.play.finished.do_registration',
  를선택해주세요 = 'classroom.play.finished.please_select',
  미설정 = 'classroom.level.unset',
  매우어려움 = 'classroom.play.finished.very_hard',
  어려움 = 'classroom.play.finished.hard',
  보통 = 'classroom.play.finished.normal',
  쉬움 = 'classroom.play.finished.easy',
  매우쉬움 = 'classroom.play.finished.very_easy',
  이해하기쉬워요 = 'classroom.play.finished.easy_to_understand',
  자료가풍부해요 = 'classroom.play.finished.a_lot_to_learn',
  강의주제가좋아요 = 'classroom.play.finished.subject_of_lecture_good',
  마지막으로 = 'classroom.play.finished.finally',
  최대300자 = 'classroom.play.finished.max_length_300',
  별로예요 = 'classroom.play.finished.not_good',
  그냥그래요 = 'classroom.play.finished.so_so',
  보통이에요 = 'classroom.play.finished.normal2',
  맘에들어요 = 'classroom.play.finished.good',
  아주좋아요 = 'classroom.play.finished.very_good',
  학습후기가정상적으로 = 'classroom.play.finished.review_successfully',
  등록과거형 = 'classroom.play.finished.registered',
  되었습니다 = 'classroom.play.finished.been',
  소중한학습후기를남겨주셔서감사합니다 = 'classroom.play.finished.thanks_review',

  // classroom api error message
  클래스룸이삭제되었거나존재하지않습니다 = 'error.400.class_room_does_not_exist',
  리뷰가삭제되었거나존재하지않습니다 = 'error.400.class_room_review_does_not_exist',
  인증이필요한클래스입니다인증후이용해주시기바랍니다 = 'error.202.class_room_get_detail_accepted',
  인증이번호가일치하지않습니다확인후다시입력해주시기바랍니다 = 'error.423.class_room_invite_code_check_accepted',
  등록된데이터가없습니다신규등록페이지로이동합니다 = 'error.204.class_room_process_no_content_source_id',
  등록된리뷰가없습니다신규등록페이지로이동합니다 = 'error.204.no_class_room_review',
  클래스룸구매자가없습니다 = 'error.204.no_class_room_purchaser',
  회원등급이강사이상인경우만가능한권한입니다 = 'error.400.Unpermission',
  클래스룸생성권한이없습니다 = 'error.401.unauthorized_post_class_room',
  클래스룸수정권한이없습니다 = 'error.401.unauthorized_put_class_room',
  클래스룸삭제권한이없습니다 = 'error.401.unauthorized_delete_class_room',
  클래스룸게시권한이없습니다 = 'error.401.unauthorized_put_class_room_is_post',
  클래스룸초대코드수정권한이없습니다 = 'error.401.unauthorized_put_class_room_invite_code',
  클래스룸프로세스생성권한이없습니다 = 'error.401.unauthorized_post_class_room_process',
  클래스룸프로세스수정권한이없습니다 = 'error.401.unauthorized_put_class_room_process',
  클래스룸프로세스삭제권한이없습니다 = 'error.401.unauthorized_delete_class_room_process',
  이미구매한클래스룸입니다 = 'error.400.already_purchased_class_room',
  내가생성한클래스룸입니다 = 'error.400.self_created_class_room',
  탈퇴한창작자의클래스룸입니다 = 'error.500.a_withdrawn_creator_class_room',
  클래스룸리뷰수정권한이없습니다 = 'error.401.unauthorized_put_class_room_review',
  클래스룸리뷰삭제권한이없습니다 = 'error.401.unauthorized_delete_class_room_review',
  이미리뷰를작성한클래스룸입니다 = 'error.400.already_wrote_class_room_review',
  내가생성한클래스룸에는리뷰를작성할수없습니다 = 'error.400.self_created_class_room_review',
  구매하지않은클래스룸에는리뷰를작성할수없습니다 = 'error.400.unpurchased_class_room_review',
  클래스룸QNA상세조회권한이없습니다 = 'error.401.unauthorized_get_class_room_qna_detail',
  클래스룸QNA질문수정권한이없습니다 = 'error.401.unauthorized_put_class_room_qna',
  클래스룸QNA질문삭제권한이없습니다 = 'error.401.unauthorized_delete_class_room_qna',
  클래스룸QNA답변권한이없습니다 = 'error.401.unauthorized_put_class_room_qna_answer',
  게시완료되고구매이력이있는클래스룸은삭제할수없습니다 = 'error.400.cannot_delete_with_a_history_of_buying_class_room_delete_class_room',
  구매하지않은클래스룸은학습할수없습니다 = 'error.400.unpurchased_class_room_learning_start',
  수강기간이만료된클래스룸은학습할수없습니다 = 'error.400.expired_class_room_learning_start',
  학습시작을안했을경우학습할수없습니다 = 'error.400.not_learning_class_room_learning_start',
  이미학습중인클래스룸입니다 = 'error.400.already_class_room_learning_start',
  강의에는학습데이터를입력할수없습니다 = 'error.400.parent_process_unable_to_create_content_id',
  학습활동을전부완료하지않았습니다 = 'error.400.fail_to_get_all_learning_time_class_room',
  내가생성한클래스룸에는질문을작성할수없습니다 = 'error.400.self_created_class_room_qna',
  구매하지않은클래스룸에는질문을작성할수없습니다 = 'error.400.unpurchased_class_room_qna',
  콘텐츠는정보는필수항목입니다제목부제목콘텐츠커버이미지중하나라도입력해주시기바랍니다 = 'error.400.class_room_is_post_check_content_id',
  제목은필수입력값입니다제목을입력해주시기바랍니다 = 'error.400.class_room_is_post_check_title',
  부제목은필수입력값입니다부제목을입력해주시기바랍니다 = 'error.400.class_room_is_post_check_sub_title',
  강의상세내용은필수입력값입니다강의상세내용을입력해주시기바랍니다 = 'error.400.class_room_is_post_check_content',
  커버이미지는필수업로드값입니다한개라도업로드해주시기바랍니다 = 'error.400.class_room_is_post_check_thumbnail',
  학년구분은필수선택값입니다학년구분을선택해주시기바랍니다 = 'error.400.class_room_is_post_check_grade',
  강의분야는필수선택값입니다강의분야를선택해주시기바랍니다 = 'error.400.class_room_is_post_check_subject',
  난이도는필수선택값입니다난이도를선택해주시기바랍니다 = 'error.400.class_room_is_post_check_level',
  가격은필수선택값입니다가격정보를선택해주시기바랍니다 = 'error.400.class_room_is_post_check_price',
  수강기한은필수선택값입니다수강기한을선택해주시기바랍니다 = 'error.400.class_room_is_post_check_expired_at',
  강의는필수입력값입니다하나라도입력해주시기바랍니다 = 'error.400.class_room_is_post_check_parent_process',
  강의제목은필수입력값입니다강의제목을입력해주시기바랍니다 = 'error.400.class_room_is_post_check_parent_process_title',
  강의가있으면활동은필수입력값입니다하나라도입력해주시기바랍니다 = 'error.400.class_room_is_post_check_sub_process',
  활동제목은필수입력값입니다활동제목을입력해주시기바랍니다 = 'error.400.class_room_is_post_check_sub_process_title',
  활동의콘텐츠는필수값입니다활동의콘텐츠를생성해주시기바랍니다 = 'error.400.class_room_is_post_check_sub_process_content',

  답변이달린문의사항은수정할수없습니다 = 'error.400.class_room_qna_update_check_answer',
  답변이달린문의사항은삭제할수없습니다 = 'error.400.class_room_qna_delete_check_answer',
  삭제된문의사항은클래스룸생성자만확인할수있습니다 = 'error.400.get_deleted_class_room_qna',

  // blockchain api error message
  지갑주소를확인할수없습니다 = 'error.400.web3_no_address_exists',
  첨부파일은필수입력업로드값입니다첨부파일을업로드해주시기바랍니다 = 'error.400.web3_no_file_exists',
  블록체인제목은필수입력값입니다블록체인제목을입력해주시기바랍니다 = 'error.400.web3_no_name_exists',
  설명은필수입력값입니다설명을입력해주시기바랍니다 = 'error.400.web3_no_description_exists',

  // 대시보드
  일평균학습시간 = 'dashboard.avgtime',
  지난7일대비하루평균$1더적은학습을진행했습니다 = 'dashboard.avgtime.studied.less',
  지난7일대비하루평균$1더많은학습을진행했습니다 = 'dashboard.avgtime.studied.more',
  지난7일대비동일한시간만큼학습을진행했습니다 = 'dashboard.avgtime.studied.same',

  오늘 = 'dashboard.today',
  지난주 = 'dashboard.lastweek',
  // 내가 찜한강의
  내가찜한강의 = 'dashboard.bookmarked',
  내가찜한강의가없습니다 = 'dashboard.no.bookmarked',
  // 추천 강의
  추천강의가없습니다 = 'dashboard.no.recommend',
  // 진행중인학습

  // $1강$2활동 ='classroom.dashboard.lecture_activity',
  강 = 'dashboard.progress.lecture',
  활동 = 'dashboard.progress.activity',
  일남음 = 'expired.left',
  기한만료 = 'tag.expired',
  진행중 = 'tag.inprogress',
  이어서학습 = 'class.continuing',

  이미진행중인학습이있습니다 = 'classroom.progress_modal.title',
  임시로저장된시점부터학습하기 = 'classroom.progress_modal.option1',
  선택한시점부터학습하기 = 'classroom.progress_modal.option2',

  진행중인학습 = 'dashboard.progress',
  진행중인학습이없습니다 = 'dashboard.no.progress',
  진행률 = 'dashboard.progress.rate',

  전체학습이력 = 'dashboard.history.total',
  학습이력이없습니다 = 'dashboard.no.history',
  완료한학습이력 = 'dashboard.history.done',
  진행중인학습이력 = 'dashboard.history.inprogress',
  진행전학습이력 = 'dashboard.before.progress',
  전체학습 = 'dashboard.history.total.class',
  완료한학습 = 'dashboard.history.done.class',
  진행전학습 = 'dashboard.history.before.class',

  내가만든클래스 = 'dashboard.myclass',
  클래스만들기 = 'dashboard.create.class',
  수강료미설정 = 'dashboard.unset.tuition',
  제목미설정 = 'dashboard.unset.title',
  키워드정보없음 = 'dashboard.unset.keyword',
  이어서작성 = 'dashboard.continue',
  전체클래스 = 'dashboard.myclass.total',
  공개클래스 = 'dashboard.myclass.public',
  비공개클래스 = 'dashboard.myclass.private',
  작성중인클래스 = 'dashboard.myclass.inprocess',
  비공개 = 'dashboard.private',

  데이터를불러오지못했습니다다시시도해주세요 = 'error.load.fail',

  // 클래스 삭제 메시지
  정말클래스를삭제하시겠습니까 = 'error.delete.confirm.title',
  삭제한클래스는복구할수없습니다 = 'error.delete.confirm.msg',
  클래스를삭제할수없습니다 = 'warning.cannot_delete_classroom',
  사용자로부터구매가완료된클래스는삭제가불가능합니다 = 'warning.cannot_delete_classroom_message',
  비밀번호입력 = 'warning.input_password',
  클래스삭제를위해서는회원님의비밀번호확인이필요합니다 = 'warning.input_password_message',
  게시물수정 = 'classroom.class.edit',
  게시물삭제 = 'classroom.class.delete',
  초대번호설정됨 = 'classroom.class.with.invitecode',
  초대번호없음 = 'classroom.class.without.invitecode',
  초대번호를입력해주세요 = 'classroom.class.invitecode.placeholder',
  $1자이하로입력해주세요 = 'classroom.class.invitecode.limit',

  기존비밀번호가존재합니다='alert.error.password.exist',

  // store api error message
  카테고리는필수선택값입니다카테고리정보를선택해주시기바랍니다 = 'error.400.store.invalid_store_category_id',
  판매유형은2개이하만등록가능합니다 = 'error.400.store.invalid_sales_type',
  유료유형일경우상품금액정보는필수값입니다상품가격을입력해주시기바랍니다 = 'error.400.store.invalid_price',
  할인기간일경우할인시작일은필수값입니다할인시작일을입력해주시기바랍니다 = 'error.400.store.invalid_discountBeginAt',
  할인기간일경우할인종료일은필수값입니다할인종료일을입력해주시기바랍니다 = 'error.400.store.invalid_discountEndAt',
  할인종료일이할인시작일보다이전일을입력할수없습니다할인기간을다시입력해주시기바랍니다 = 'error.400.store.invalid_discountBeginAt_after_discountEndAt',
  스토어제목은필수입력값입니다스토어제목을입력해주시기바랍니다 = 'error.400.store.invalid_title',
  스토어판매시판매동의체크는필수입니다판매동의를체크해주시기바랍니다 = 'error.400.store.invalid_is_agree',
  유효하지않은학습도구입니다 = 'error.400.store.invalid_member_content_uuids',
  같은종류의학습도구만업로드가능합니다 = 'error.400.store.invalid_content_type_id',
  존재하지않는스토어입니다 = 'error.400.store.invalid_store_uuid',
  유효하지않는스토어판매유형입니다 = 'error.400.store.invalid_sales_type_uuid',
  구매동의를체크해주세요 = 'error.400.store.invalid_is_agree',
  이미구매한스토어입니다 = 'error.400.store.already_purchased_store',
  내가등록한스토어입니다 = 'error.400.store.self_created_store',
  내가구매한스토어가아닙니다 = 'error.400.store.not_purchased_store',
  환불가능한스토어가아닙니다 = 'error.400.store.failed_to_get_my_purchase_history_store',
  마일리지로만구매한스토어는환불이불가능합니다 = 'error.400.store.not_a_purchase_made_with_point_only',
  이미환불한스토어입니다 = 'error.400.store.already_refund_store',
  // sales-manager api error message
  유효하지않은스토어입니다 = 'error.400.sales-manager.invalid_store_uuid',
  내가등록한스토어가아닙니다 = 'error.400.sales-manager.not_my_store',
  유효하지않은클래스룸입니다 = 'error.400.sales-manager.invalid_class_room_uuid',
  내가등록한클래스룸이아닙니다 = 'error.400.sales-manager.not_my_class_room',
  유효하지않은판매상품종류입니다 = 'error.400.sales-manager.invalid_type',

  // 모달 공통 에러
  요청하신작업을수행하지못했습니다 = 'alert.error.try.fail',
  잠시후다시시도해주세요 = 'alert.error.try.again',

  로그인이필요합니다 = 'disallow.401.need_login',
  로그인후이용해주세요 = 'please_login',
  최적의브라우저환경에서STEAMuP을만나보세요 = 'disallow.Title',
  최신버전의최적화브라우저로업그레이드하시기바랍니다 = 'disallow.Causation',
  최신버전의Chrome브라우저사용을권장합니다 = 'disallow.Description',

  홈으로돌아가기 = 'goto.Home',
  다음 = 'auth.button.next',
  Google로계속하기 = 'login.button.google',
  Facebook으로계속하기 = 'login.button.facebook',
  테스트계정로그인 = 'login.button.testaccount',

  이메일을입력하세요 = 'input.type.email',
  가입하실이메일을입력하세요 = 'input.type.email_for_join',
  가입한이메일주소를입력해주세요 = 'enter.registered.email',
  계정이없으신가요 = 'input.type.does_not_have_email',
  보다안전한서비스이용을위해비밀번호를설정해주세요 = 'auth.login.reset.pw.message',
  보다안전한서비스이용을위해비밀번호를재설정해주세요 = 'auth.login.reset.pw.reset.message',

  이미계정이있으신가요 = 'input.type.already_have_account',
  회원이아닙니다 = 'error.text.email_does_not_exist',
  아이디또는비밀번호를잘못입력했습니다 = 'error.text.Invalid_email_or_pw',
  입력한이메일이올바르지않습니다 = 'error.text.not_a_valid_email',
  등록되지않은이메일입니다='error.text.unregistered_email',
  올바른형식의이메일이아닙니다 = 'error.text.InvalidEmail',
  올바른형식의비밀번호가아닙니다 = 'error.text.InvalidPw',
  이전 = 'common.back',
  스팀업에오신걸환영합니다 = 'text.welcome',
  회원이되시면보다다양한혜택을받아보실수있습니다 = 'text.please_signup',
  회원유형을선택해주세요 = 'text.select_member_type',
  일반회원 = 'member.general',
  강사회원 = 'member.creator',
  스팀업사이트에서제공하는서비스를이용하는회원 = 'member.general.explain',
  클래스등록및운영관리서비스를이용하는회원 = 'member.creator.explain',
  강사회원가입 = 'member.join.creator',
  닉네임 = 'input.creator.nickname',
  닉네임을입력해주세요 = 'input.type.nickname',
  강사회원정보 = 'member.creator.info',
  소속 = 'member.creator.belong',
  소속정보를입력해주세요 = 'input.type.belong',
  연락처 = 'member.creator.phone',
  전화번호를입력해주세요 = 'input.type.phone',

  회원가입완료 = 'signup.complete',
  스팀업회원이되신걸진심으로환영합니다 = 'signup.welcom',
  스팀업시작하기 = 'signup.start',
  비밀번호찾기 ='signup.find.password',

  비밀번호와같지않습니다 = 'error.text.InvalidConfirm',
  새로운비밀번호를입력해주세요 = 'input.type.new_password',
  숫자와특수문자를포함한8글자이상을입력해주세요 = 'input.type.new_password_rule',
  숫자또는대시만입력가능합니다 = 'error.text.InvalidPhoneNum',
  소속은최소$1자이상입력해주세요 = 'common.validator.belong.input_min_length',
  소속은최대$1자이하까지입력가능합니다 = 'common.validator.belong.input_max_length',
  올바른형식이아닙니다 = 'error.text.Invalid',
  계정탈퇴가진행중입니다 = 'account.delete.continue',
  탈퇴취소 = 'account.delete.cancel_btn',
  안내 = 'text.information',
  비밀번호를설정해주세요 = 'user.password.input',
  비밀번호재설정완료 = 'password.reset.complete',
  새로운비밀번호설정이완료되었습니다 = 'new.password.setting',
  간편회원가입 = 'simple.membership.registration',
  회원가입축하기념으로1000P적립해드렸어요 = 'celebrate.signup.point',
  스팀업회원이되신것을환영합니다 = 'welcome.steamup',
  로그인화면으로가기 = 'back.login',
  창작자소개 = 'creator.introduction',
  완료 = 'complete',
  작성된창작자소개가없습니다 = 'no.creator.introduction.created',
  소개글이없습니다 = 'no.introduction',
  전체콘텐츠 = 'full.content',
  대표콘텐츠가등록되지않았습니다 = 'representative.content.no.registered',
  생성된콘텐츠가없습니다 = 'no.content.created',
  배경이미지변경 = 'change.background',
  기본배경색상 = 'basic.background.color',
  내PC에서업로드 = 'upload.my.pc',
  이미지찾기 = 'find.image',
  적용 = 'application',
  이미지는최대10mb미만인pngjpggif를업로드할수있어요 = 'image.upload.condition',
  프로필이미지변경 = 'change.profile.image',
  기본프로필색상 = 'basic.profile.color',
  명이좋아합니다 = 'like.count',
  $1님이좋아합니다 = 'following.like.count',
  $1님외$2명이좋아합니다 = 'following.like.count_and_others',
  정렬하기 = 'arrange',
  대표클래스 = 'main.class',
  대표클래스가등록되지않았습니다 = 'representative.class.not',
  대표콘텐츠등록 = 'resigster.represenatative',
  대표콘텐츠는최대10개까지등록가능합니다 = 'register.contents.10',
  대표클래스는최대10개까지등록가능합니다 = 'register.class.10',
  페이스북공유 = 'share.facebook',
  트위터공유 = 'share.twitter',
  SNS공유하기 = 'share.sns',
  URL공유하기 = 'share.url',
  복사 = 'copy',
  주소가복사되었습니다 = 'copy.url',
  등록 = 'registration',
  댓글을입력해주세요최대500자 = 'Please.type.in.the.comments.500',
  댓글삭제 = 'delete.comment',
  자 = 'charachters.count',
  관련게시물 = 'related.posts',
  전체보기 = 'full.view',
  필터 = 'filter',
  추천키워드 = 'recomment.keyword',
  클래스가없습니다 = 'no.class',
  대표클래스등록 = 'main.class.register',
  대표클래스가등록되어있지않습니다 = 'main.class.no',
  내클래스 = 'my.class',
  내클래스에서검색 = 'myclass.search_in_myclass',
  생성된클래스가없습니다 = 'no.class.register',
  클래스파일을선택해주세요 = 'please.select.class',
  원하는클래스를검색해보세요 = 'search.class',
  학습시작하기 = 'start.class',
  없음 = 'absence',
  있음 = 'exist',
  강의소개 = 'introduction.class',
  학습후기 = 'review.class',
  추천강의 = 'recommendation.class',
  무료 = 'free.charge',
  명이수강했습니다 = 'of.us.took.the.class',
  강의정보요약 = 'course.information.summary',
  강의정보 = 'course.information',
  학습만족도 = 'learning.satisfaction',
  학습만족도가등록되어있지않습니다 = 'no.learning.satisfaction',
  학습난이도 = 'learning.difficulty.level',
  학습난이도가등록되어있지않습니다 = 'no.learning.difficulty.level',
  학습활용도 = 'learning.utilization',
  학습활용도가등록되어있지않습니다 = 'no.learning.utilization',
  수강생학습후기 = 'student.review',
  수강생학습후기가등록되어있지않습니다 = 'no.student.review',
  총 = 'total',
  총$1개의후기가등록되었어요 = 'study.review.registered',
  강사 = 'teacher',
  교수 = 'advisor',
  연구원 = 'consultant',
  소개 = 'introduction',
  포스팅 = 'posting',
  수강후기 = 'creator.info.study.review',
  나에게맞는맞춤형강의를확인해보세요 = 'check.fit.class',
  확인하러가기 = 'go.to.check',
  진행중인학습이있어요 = 'underway.learning',
  강사소개 = 'introduction.teacher',
  접기 = 'comment.fold',
  찜한상품 = 'bookmark.product',
  찜한상품에추가되었습니다 = 'bookmark.product.add',
  찜한상품에서삭제되었습니다 = 'bookmark.product.delete',
  보러가기 = 'go.show',
  현재서비스준비중입니다 = 'currently.preparing',
  보다나은서비스제공을위해준비중에있습니다 = 'service.preparing',
  빠른시일내에서비스를제공하겠습니다 = 'service.fast.days',
  팔로우한창작자가없습니다 = 'no.follow.creator',
  팔로우한사용자가없습니다 = 'no.follow.user',
  인기클래스 = 'popular.class',
  신규클래스 = 'new.class',
  클래스입장하기 = 'enter.class',
  초대번호가설정된클래스입니다 = 'please.invite.code',
  초대번호 = 'invite.code',
  입장 = 'entering',
  창작자가없습니다 = 'no.creator',
  대표클래스선택 = 'select.main.class',
  클래스를선택해주세요 = 'please.select.main.class',
  대표콘텐츠선택 = 'select.main.contents',
  공개비공개 = 'public.private',
  강의종료 = 'finish.lecture',
  총$1개의질문이등록되었어요 = 'total.question.enrollment',
  학습후기등록이완료된클래스입니다 = 'already.written.review',
  크롬다운로드 = 'chrome.download',
  전체서비스 = 'full.service',
  내정보관리 = 'manage.my.information',
  자주묻는질문 = 'always.question',
  세부유형선택 = 'select.detail.type',
  복구요청하기 = 'request.restore',
  기술지원 = 'tech.support',
  고객지원유형선택 = 'customer.support.type',
  관리자 = 'manager',
  번호 = 'number',
  제목 = 'title',
  첨부파일 = 'attached.file',
  작성자 = 'writer',
  등록일자 = 'enrollment.date',
  조회수 = 'view.count',
  답변 = 'answer',
  복구요청취소 = 'cancel.recovery.request',
  목록으로 = 'back.list',
  제출에성공하였습니다 = 'success.submit',
  전체유형 = 'total.type',
  이메일질문 = 'email.question',
  이메일문의 = 'email.enquiries',
  /** 끝 * */

  올바른이메일이아닙니다 = 'error.text.wrongemail',
  서버오류입니다 = 'error.text.server',
  로그인이취소되었습니다 = 'login.text.cancel',
  로그인정보가없습니다 = 'login.text.noinform',
  로그인진행중입니다 = 'login.text.continue',

  이메일인증 = 'login.verificated.email',
  새이메일등록 = 'login.new.email',
  비밀번호재설정 = 'login.new.password',
  인증코드를확인했습니다 = 'login.check.code',

  이메일전송에실패했습니다잠시후다시시도해주세요 = 'error.send.email',
  이메일을다시전송했습니다이메일보관함을확인해주세요 = 'error.send.re',
  인증유효시간이지났습니다다시진행해주세요 = 'error.verificated.time',
  인증코드를입력해주세요 = 'input.type.code',
  인증코드입력5회이상실패했습니다다시시도해주세요 = 'inputcode.too_many_fail',
  인증코드가틀렸습니다다시확인해주세요 = 'inputcode.wrong_code',

  입력한이메일로인증이메일을발송합니다 = 'send.verificated.email',
  이메일보내기 = 'send.email',
  이메일로전송된인증코드를입력하여인증을완료해주세요 = 'send.check.code',
  인증코드입력 = 'send.type.code',

  남은시간 = 'time.left',
  시간 = 'time.hour',
  분 = 'time.minute',
  초 = 'time.second',
  시간초과 = 'time.over',

  이메일을받지못했나요 = 'email.send.not',
  이메일재전송 = 'email.send.re',
  인증코드가일치하지않습니다다시시도해주세요 = 'code.does.not.match',
  인증에성공하였습니다 = 'code.sucess',

  이미사용중인이메일입니다다른이메일을입력하세요 = 'email.type.already',
  추가이메일인증 = 'email.verificated.add',
  사용하실계정의최초이메일인증이필요합니다 = 'email.verificated.first',

  약관에동의해주세요 = 'stipulation.agree',
  서비스이용을위해약관동의가필요합니다 = 'stipulation.use.service',
  STEAMuP서비스이용약관동의 = 'stipulation.use.steamup',
  개인정보수집및이용에동의 = 'stipulation.agree.personal',

  비밀번호확인란을입력해주세요 = 'password.input',
  입력한두비밀번호가다릅니다 = 'password.wrong.input',
  비밀번호변경이완료되었습니다로그인화면으로이동합니다 = 'password.change.finish',
  새로운비밀번호를입력하여재설정을완료해주세요 = 'password.new.finish',
  현재비밀번호 = 'password.now',
  새비밀번호 = 'password.new',
  새비밀번호를입력하세요 = 'password.new.input',
  새비밀번호확인 = 'password.new.check',
  새비밀번호를다시입력해주세요 = 'password.new.recheck',

  인증절차가제대로진행되지않았습니다다시시도해주세요 = 'password.again',
  추가정보입력 = 'password.add',
  STEAMuP에서사용할이름과새로운비밀번호를입력하세요 = 'new.password.name',
  비밀번호를입력해두면다음에로그인이편리합니다 = 'password.next.convenience',
  이름 = 'new.name',
  비밀번호 = 'input.password',
  비밀번호확인 = 'password.check',
  다음에설정하기 = 'password.later',
  로그인화면으로돌아가기 = 'back.login.monitor',
  알수없는이유로로그인을실패하였습니다 = 'error.login.cancel',

  비밀번호를5회이상잘못입력하셨습니다비밀번호찾기를통해비밀번호를변경해주세요 = 'passsword.wrong.five',
  비밀번호가일치하지않습니다 = 'password.incorrect.input',
  비밀번호를입력하세요 = 'password.text.input',
  비밀번호를잊으셨나요 = 'password.text.forget',

  계정탈퇴가취소되었습니다다시로그인해주세요 = 'account.delete.cancel',

  // 탈퇴한 사용자 메시지
  해당사용자가탈퇴되어삭제대기중입니다삭제예정일전에탈퇴를취소하고계정을다시이용할수있습니다그러나삭제예정일이경과하면사용자정보가삭제되며다시복구할수없습니다 = 'account.delete_message',
  해당사용자가탈퇴되어삭제대기중입니다 = 'account.delete.wait',
  삭제예정일전에탈퇴를취소하고계정을다시이용할수있습니다 = 'account.delete.before',
  그러나삭제예정일이경과하면사용자정보가삭제되며다시복구할수없습니다 = 'account.delete.after',
  삭제예정일 = 'account.delete.date',
  돌아가기 = 'goto.back',
  삭제취소하기 = 'cancel.delete',
  도움말 = 'creator.popular.help',
  인기창작자란 = 'creator.popular.help_title',
  인기창작자설명1 = 'creator.popular.help.desc1',
  인기창작자설명2 = 'creator.popular.help.desc2',
  인기창작자 = 'creator.popular',
  원하는창작자를검색해보세요 = 'creator.search_placeholder',
  팔로워 = 'creator.follower',
  대표콘텐츠 = 'creator.maincontent',
  팔로워목록 = 'creator.followedby',
  서비스 = 'footer.technology_service',
  소식 = 'footer.steamup_news',
  뉴스 = 'footer.news',
  커뮤니티 = 'footer.community',
  고객센터 = 'footer.service_center',
  질문과답변 = 'footer.qna',
  자주하는질문 = 'footer.faq',
  회사소개 = 'footer.about',
  회사 = 'footer.company',

  초등수학 = 'service.elementary_math',
  디지털교과서 = 'service.digital_textbook',
  중등수학 = 'service.middle_math',
  수학문제이미지 = 'service.mathgrida',
  협력수학 = 'service.mathcollabo',
  수학그래프검색기 = 'service.mathoncloud',
  API서비스 = 'service.mathcore_api',

  // 튜토리얼
  튜토리얼 = 'menu.tutorial',
  카테고리선택 = 'tutorial.category',
  $1에튜토리얼이없습니다 = 'tutorial.category.no_contents',
  튜토리얼이없습니다 = 'tutorial.category.no_tutorial',
  목록으로돌아가기 = 'tutorial.detail.go_back',
  전체난이도 = 'tutorial.filter.title',

  // 커뮤니티 이메일 질문하기
  질문시이메일은필수입력값입니다이메일을입력해주시기바랍니다 = 'error.400.invalid_email',
  질문시질문유형은필수선택값입니다질문유형을선택해주시기바랍니다 = 'error.400.invalid_questionType',
  질문시제목은필수입력값입니다제목을입력해주시기바랍니다 = 'error.400.invalid_title',
  질문시내용은필수입력값입니다내용을입력해주시기바랍니다 = 'error.400.invalid_content',
  답변시내용은필수입력값입니다내용을입력해주시기바랍니다 = 'error.400.invalid_answer_content',

  // 어드민 공통
  한글제목은필수입력값입니다한글제목을입력해주시기바랍니다 = 'error.400.invalid_ko_title',
  한글내용은필수입력값입니다한글내용을입력해주시기바랍니다 = 'error.400.invalid_ko_content',
  영문제목은필수입력값입니다영문제목을입력해주시기바랍니다 = 'error.400.invalid_en_title',
  카테고리는필수선택값입니다카테고리를선택해주시기바랍니다 = 'error.400.invalid_category',
  학습도구는필수입력값입니다학습도구를작성하여주시기바랍니다 = 'error.400.invalid_tool',
  자주묻는질문종류는필수입력값입니다자주묻는질문종류를작성하여주시기바랍니다 = 'error.400.invalid_board_faq_type',

  // 어드민 튜토리얼 페이지 에러 메세지
  튜토리얼공개권한이없습니다 = 'error.401.unauthorized_put_readable_tutorial_content_is_readable',

  // 어드민 공지사항 페이지 에러 메세지

  // 메타버스 페이지
  메타버스 = 'metaverse',
  메타버스다운로드메시지='metaverse.download.message',
  메타버스다운로드 = 'metaverse.download',

  // nft 번역
  네트워크를확인해주세요 = 'nft.check.network',
  사용을위해먼저네트워크를변경해주세요='nft.change.network',
  새로고침이완료되었습니다 = 'nft.refresh.msg',
  지갑연결에성공했습니다='nft.success.connet.wallet',
  지갑연결에실패했습니다='nft.fail.connet.wallet',
  데스크탑환경에서사용해주세요='nft.use.desktop.env',
  먼저블록체인네트워크에지갑을연결해주세요='nft.connet.wallet.msg',
  지갑연결하기='nft.connet.wallet',
  사용을위해먼저브라우저에지갑을설치해주세요='nft.download.wallet.msg',
  Chrome웹스토어로이동='nft.download.wallet',

  지갑주소가클립보드에복사되었습니다='nft.copy.address.msg',
  지갑연결='nft.connet.wallet.state',
  지갑주소 ='nft.wallet.address',
  주소복사='nft.copy.address',
  nft발급하기='nft.mint.nft',

  발급실패='nft.fail.mint.nft',
  전체nft='nft.all.list',
  내nft='nft.my.list',
  nft토큰발급진행중입니다='nft.transfer.msg',
  nft발급중에러가발생했습니다='nft.transfer.error.msg',

  제목을입력해주세요='nft.title.msg',
  설명='nft.desc',
  설명을입력해주세요='nft.desc.msg',
  콘텐츠업로드='nft.upload.content',
  콘텐츠를업로드해주세요='nft.upload.content.msg',
  대표이미지변경='nft.change.thumbnail.img',
  다른콘텐트선택하기='nft.change.other.content',

  api요청중오류발생='nft.opensea.api.error',

  소유자주소='nft.owner.address',
  opensea에서보기='nft.goto.opensea',

  NFT='nft.nft',
  그외nft살펴보기='nft.goto.other.nft',

  네트워크추가에실패했습니다브라우저확장프로그램버튼을확인해주세요='nft.error.add.network',
  네트워크변경에실패했습니다브라우저확장프로그램버튼을확인해주세요='nft.error.switch.network',

  내NFT목록을가져오는데실패했습니다다시시도해주세요='nft.error.getNFTs',
  전체NFT목록을가지고오는데실패했습니다다시시도해주세요='nft.error.getNFTsByContract',
  네트워크를확인할수없습니다로그인상태를확인해주세요='nft.error.check.login',
  메타마스크로그인상태를확인해주세요='nft.error.check.meta.login',

  생성된NFT가없습니다='nft.no_nft_list',

  통계도구='statistics.tool',

  // 디지털교과서
  수학='digitaltextbook.math',
  과학='digitaltextbook.science',
  정보='digitaltextbook.information',
}

export default Message;
